"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClosedSaleMessage = void 0;
const lang_1 = require("../../../utils/lang");
const builders_1 = require("../builders");
const getClosedSaleMessage = (params) => {
    const header = builderHeader(params);
    const footer = builderFooter(params);
    return `${header}${footer}`;
};
exports.getClosedSaleMessage = getClosedSaleMessage;
const builderHeader = ({ cycleNumber, businessUnit }) => {
    const texts = lang_1.BRAND_TEXTS[businessUnit];
    return `Oi, tudo bem?\n\nEstou te enviando os produtos que quero do ciclo ${cycleNumber} d${texts.nameWithPrefix}.\n\n`;
};
const builderFooter = ({ totalPrice, orderBackofficeId, reseller }) => {
    let message = `*Valor total: ${totalPrice}*\n\n`;
    message += '*Valide os detalhes desta venda:*\n';
    message += `${(0, builders_1.buildShareOrderPageLink)(orderBackofficeId, reseller.catalogSlug)}`;
    return message;
};
